/**
 * Exercise API Service
 * Handles all API calls for Practice Exercises
 */
import apiClient from '../apiClient';

const BASE_URL = '/api/exercises';

/**
 * Get all exercises (own + public)
 */
export const getExercises = async () => {
  const response = await apiClient.get(`${BASE_URL}/`);
  return response.data;
};

/**
 * Get own exercises only
 */
export const getMyExercises = async () => {
  const response = await apiClient.get(`${BASE_URL}/my/`);
  return response.data;
};

/**
 * Get public exercises only
 */
export const getPublicExercises = async () => {
  const response = await apiClient.get(`${BASE_URL}/public/`);
  return response.data;
};

/**
 * Get exercises by game type
 */
export const getExercisesByGameType = async (gameTypeId) => {
  const response = await apiClient.get(`${BASE_URL}/by_game_type/`, {
    params: { game_type: gameTypeId }
  });
  return response.data;
};

/**
 * Get single exercise by ID
 */
export const getExercise = async (id) => {
  const response = await apiClient.get(`${BASE_URL}/${id}/`);
  return response.data;
};

/**
 * Create new exercise
 */
export const createExercise = async (exerciseData) => {
  const response = await apiClient.post(`${BASE_URL}/`, exerciseData);
  return response.data;
};

/**
 * Update exercise
 */
export const updateExercise = async (id, exerciseData) => {
  const response = await apiClient.put(`${BASE_URL}/${id}/`, exerciseData);
  return response.data;
};

/**
 * Delete exercise
 */
export const deleteExercise = async (id) => {
  const response = await apiClient.delete(`${BASE_URL}/${id}/`);
  return response.data;
};
